import { getUserAction, commonGetAction } from './axios'
import md5 from 'js-md5'

// --------------- 登录 模块 ---------------
/**
 * 手机号+验证码登录
 * @param {string} deviceId 设备ID
 * @param {string} deviceName 设备名称
 * @param {int} channel 登录来源
 * @param {string} mobile 手机号
 * @param {string} vcode 验证码
 */
export const loginAccountWithVcodeAction = (deviceId, deviceName, channel, mobile, vcode) => {
  return commonGetAction('LoginWithVcode', {}, {
    'deviceId': deviceId,
    'deviceName': deviceName,
    'channel': channel,
    'mobile': mobile,
    'vcode': vcode
  })
}
/**
 * 获取登录验证码
 * @param {string} mobile 手机号
 */
export const getLoginVcodeAction = (mobile) => {
  return commonGetAction('GetLoginVcode', {}, {
    'mobile': mobile
  })
}
/**
 * 账号+密码登录
 * @param {string} deviceId 设备ID
 * @param {string} deviceName 设备名称
 * @param {int} channel 登录来源
 * @param {string} mobile 手机号
 * @param {string} passwd 登录密码（md5加密）
 */
export const loginWithPasswordAction = (deviceId, deviceName, channel, mobile, passwd) => {
  return commonGetAction('LoginWithPasswd', {}, {
    'deviceId': deviceId,
    'deviceName': deviceName,
    'channel': channel,
    'mobile': mobile,
    'passwd': md5(passwd)
  })
}
/**
 * 获取修改密码的验证码(GetUserForgetPasswd)
 * @param {string} mobile 手机号
 */
export const getUserForgetPasswdAction = (mobile) => {
  return commonGetAction('GetUserForgetPasswd', {}, {
    'mobile': mobile
  })
}
/**
 * 修改密码（忘记密码）(UpdateUserPasswdByVcode)
 * @param {string} mobile 手机号
 * @param {string} vcode 验证码
 * @param {string} passwd 登录密码（md5加密）
 */
export const updateUserPasswdByVcodeAction = (mobile, vcode, passwd) => {
  return commonGetAction('UpdateUserPasswdByVcode', {}, {
    'mobile': mobile,
    'vcode': vcode,
    'passwd': md5(passwd)
  })
}
/**
 * 自动登录（uid+uuid+session登录）
 * @param {string} deviceId 设备ID
 * @param {string} deviceName 设备名称
 * @param {int} channel 登录来源
 * @param {int} uid 用户ID
 * @param {string} session 用户session
 */
export const loginWithSessionAction = (deviceId, deviceName, channel, uid, session) => {
  return commonGetAction('LoginWithSession', {}, {
    'deviceId': deviceId,
    'deviceName': deviceName,
    'channel': channel,
    'uid': uid,
    'session': session
  })
}
/**
 * 用户登录（key + token登录，获取初始化信息）(LoginUser)
 */
export const LoginUserAction = () => {
  return getUserAction('LoginUser', {})
}

// --------------- 会员卡 模块 ---------------
/**
 * 获取会员卡列表（ShowCardList）
 */
export const showCardListAction = (begin, count) => {
  return getUserAction('ShowCardList', {
    'begin': begin,
    'count': count
  })
}
/**
 * 会员卡详细信息(ShowCard)
 */
export const showCardAction = (sid) => {
  return getUserAction('ShowCard', {
    'sid': sid
  })
}
/**
 * 会员卡余额信息(ShowCardDetailed)
 */
export const showCardDetailedAction = (sid) => {
  return getUserAction('ShowCardDetailed', {
    'sid': sid
  })
}
/**
 * 会员卡共享(ShareCard)
 * @param {int} sid 商户ID
 * @param {string} mobile 被共享人手机号
 * @param {string} name 被共享人名字
 * @param {int} cardType 商户的会员卡类型
 */
export const shareCardAction = (sid, mobile, name, cardType) => {
  return getUserAction('ShareCard', {
    'sid': sid,
    'mobile': mobile,
    'name': name,
    'cardType': cardType
  })
}
/**
 * 获取共享人列表(ShowShareList)
 * @param {int} sid 商户ID
 */
export const showShareListAction = (sid) => {
  return getUserAction('ShowShareList', {
    'sid': sid
  })
}
/**
 * 会员消费记录列表(ShowOrderList)
 */
export const showOrderListAction = (sid) => {
  return getUserAction('ShowOrderList', {
    'sid': sid
  })
}
/**
 * 活动详细(ShowActivity)
 */
export const showActivityAction = (sid) => {
  return getUserAction('ShowActivity', {
    'sid': sid
  })
}
/**
 * 会员卡二维码(ShowBarCode)
 */
export const showBarCodeAction = (sid) => {
  return getUserAction('ShowBarCode', {
    'sid': sid
  })
}
/**
 * 获取信息列表(ShowMsgList)
    // search(
    //     'type'=>'int',          // 消息类型, -1：所有消息 0:普通消息, 1:充值通知，2:消费通知, 3:系统公告
    //     'isRead'=>'int',        // 消息阅读状态，-1:所有消息，0:未读消息，1:已读消息
    //     'isRemove' => 'int',    // 消息状态， 0正常消息，1已删除消息
    // ),
 */
export const showMsgListAction = (begin, count, search) => {
  let pageShow = {
    'begin': begin,
    'count': count,
    'search': search
  }
  return getUserAction('ShowMsgList', pageShow)
}
/**
 * 信息详细信息(ShowMsg)
 */
export const showMsgAction = (msgId, type) => {
  return getUserAction('ShowMsg', {
    'msgId': msgId,
    'type': type
  })
}

// --------------- 我的 模块 ---------------
/**
 * 获取用户手机和密码状态(AccountSecurity)
 */
export const accountSecurityAction = () => {
  return getUserAction('AccountSecurity', {})
}
/**
 * 设置密码(GetUserPasswd)
 * @param {string} passwd 加密前密码
 */
export const getUserPasswdAction = (passwd) => {
  return getUserAction('GetUserPasswd', {
    'passwd': md5(passwd)
  })
}
/**
 * 修改密码(UpdateUserPasswd)
 * @param {string} oldpasswd 加密前旧密码
 * @param {string} newpasswd 加密前新密码
 */
export const updateUserPasswdAction = (oldpasswd, newpasswd) => {
  return getUserAction('UpdateUserPasswd', {
    'oldpasswd': md5(oldpasswd),
    'newpasswd': md5(newpasswd)
  })
}
/**
 * 获取换绑手机号用的验证码(GetUserChangeMobile)
 * @param {string} mobile 新手机号
 */
export const getUserChangeMobileAction = (mobile) => {
  return commonGetAction('GetUserChangeMobile', {}, {
    'mobile': mobile
  })
}
/**
 * 更换绑定手机(UpdateUserMobile)
 * @param {string} mobile 新手机号
 * @param {string} vcode 验证码
 */
export const updateUserMobileAction = (mobile, vcode) => {
  return getUserAction('UpdateUserMobile', {
    'mobile': mobile,
    'vcode': vcode
  })
}
/**
 * 获取用户信息(ShowUser)
 */
export const showUserAction = () => {
  return getUserAction('ShowUser', {})
}
/**
 * 修改用户信息(UpdateUser)
 * @param {int} sex         用户性别，特别的：`-1` 表示不更新性别
   @param {string} avatar   用户头像ID
   @param {string} nick     用户昵称
   @param {string} address  用户地址
   @param {string} info     用户签名
   @param {string} birthday 用户公历生日
   @param {string} identity 用户身份证号码
 */
export const updateUserAction = (sex, avatar, nick, address, info, birthday, identity) => {
  let userInfo = {}
  if (sex !== -1) userInfo.sex = sex
  if (avatar) userInfo.avatar = avatar
  if (nick) userInfo.nick = nick
  if (address) userInfo.address = address
  if (info) userInfo.info = info
  if (birthday) userInfo.birthday = birthday
  if (identity) userInfo.identity = identity
  return getUserAction('UpdateUser', {
    user: userInfo
  })
}
/**
 * 获取我的消费列表(ShowAllOrderList)
 */
export const showAllOrderListAction = () => {
  return getUserAction('ShowAllOrderList', {})
}



// WEBPACK FOOTER //
// ./src/assets/js/api.js